<div class="modal-content">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" (click)="close()"></button>
    </div>
    <div class="modal-body p-4">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row my-gallery gallery" id="aniimated-thumbnials" gallerize>
                                @for (img of imgData ; track img) {
                                    <figure class="col-md-3 col-6 img-hover hover-1" style="margin-bottom: 30px;" itemprop="associatedMedia"
                                            itemscope="">
                                        <a [href]="img.srcUrl" target="_blank" itemprop="contentUrl">
                                            <div style="overflow: hidden;">
                                                <img [src]="img.previewUrl" itemprop="thumbnail" alt="Image description">
                                            </div>
                                        </a>
                                    </figure>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
